module.exports = __webpack_public_path__ + "img/fire-icon.01ac2bf8.svg";